import { HttpRequest } from "../Config/APIConnection";

export const Get_Category = async () => {
  return await HttpRequest("GET", "/category", null, true);
};

export const Get_Job = async () => {
  return await HttpRequest("GET", "/category/job", null, true);
};

export const Get_Doctor = async () => {
  return await HttpRequest("GET", "/category/doctor", null, true);
};

export const Get_Trip = async () => {
  return await HttpRequest("GET", "/category/trip", null, true);
};
